var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, EmptyState, InputSelectionList, SelectionList, Text, } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { ratingApi } from 'apis/rating';
import styles from './surveySelect.module.scss';
/** Represents the component for selecting a survey. */
export const SurveySelect = ({ selectedSurvey, onSelect, }) => {
    const { surveys, isSuccess } = ratingApi.useReadRatingSettingsQuery({
        level: 'survey',
        surveyType: 'text_to_speech',
    }, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { surveys: data === null || data === void 0 ? void 0 : data.data.rating_settings }));
        },
    });
    /** Handles selecting a survey. */
    const handleOnSelect = useCallback((survey) => {
        onSelect(survey);
    }, [onSelect]);
    return (_jsxs(InputSelectionList, Object.assign({ value: selectedSurvey ? [selectedSurvey] : [], onChange: (e) => handleOnSelect(e.selectedValues[0]), getItemTitleByValue: (survey) => { var _a; return (_a = survey === null || survey === void 0 ? void 0 : survey.name) !== null && _a !== void 0 ? _a : '-'; }, disabled: !isSuccess, dropdownProps: {
            className: styles.inputSelectionDropdown,
        }, placeholder: 'Select a survey' }, { children: [surveys === null || surveys === void 0 ? void 0 : surveys.map((survey) => {
                return (_jsx(SelectionList.Item, Object.assign({ value: survey }, { children: _jsx(Text.Paragraph, { children: survey.name }) }), survey.id));
            }), !(surveys === null || surveys === void 0 ? void 0 : surveys.length) && (_jsx(Box, Object.assign({ as: "li", padding: "300" }, { children: _jsx(EmptyState, { title: "No surveys found", description: "Try changing your search criteria." }) })))] })));
};
